import React, { useState } from 'react';
import { useTranslation } from 'react-i18next/';
import { faPlus, faTimes } from '@fortawesome/pro-regular-svg-icons';

import ErrorHelper from '@helpers/ErrorHelper';
import { useLocale } from '@hooks/useLocale';

import { useStores } from '@models/RootStore/RootStore';
import { BaseListItem } from '@components/containers';
import Button from '../Button/Button';

import Props from './VisitedListItem.props';

const VisitedListItem = ({ tip, className }: Props) => {
  const { t } = useTranslation();
  const locale = useLocale();
  const { UserStore } = useStores();
  const isDP = locale === 'nl-NL';

  const [isLoading, setLoading] = useState(false);

  const handlePress = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent> | void) => {
    if (e) e.preventDefault();

    setLoading(true);

    try {
      await UserStore.toggleVisited(tip.id);
    } catch (e) {
      ErrorHelper.handleGenericError();
    } finally {
      setLoading(false);
    }
  };

  const RenderButton = () => {
    return (
      <Button
        icon={UserStore.hasVisited(tip.id) ? faTimes : faPlus}
        iconPosition="left"
        isLoading={isLoading}
        onPress={handlePress}>
        {UserStore.hasVisited(tip.id)
          ? t('DOMAIN.BUCKETLIST.REMOVE_FROM_VISITED')
          : t('DOMAIN.BUCKETLIST.ADD_TO_VISITED')}
      </Button>
    );
  };

  return (
    <BaseListItem
      {...tip}
      likecount={isDP ? tip.bookmarkCount : tip.bookmarkCountEN ? tip.bookmarkCountEN + 100 : 100}
      className={className}
      buttons={RenderButton()}
    />
  );
};

export default VisitedListItem;
